import { CatastiClient } from "../generated";
import { BaseUrl } from "../BaseClient";
import { ValidationError } from "../common/validationError";

export type { ValidationError };

const SIERT_ID_STORAGE_KEY = "catasti_siert_id_azienda";

class CatastiActions {

    getSavedIdAziendaSiert(): number {
        const saved = localStorage.getItem(SIERT_ID_STORAGE_KEY);
        return saved ? parseInt(saved) || 0 : 0;
    }

    saveIdAziendaSiert(id: number): void {
        localStorage.setItem(SIERT_ID_STORAGE_KEY, id.toString());
    }

    /**
     * Chiama /catasti/siert/check e ritorna la lista di errori di validazione.
     * Ritorna sempre (non lancia eccezioni per errori di business): array vuoto = tutto ok.
     */
    async checkSiert(idInterventi: number[], idAziendaSiert: number): Promise<ValidationError[]> {
        const params = new URLSearchParams({
            idInterventi: idInterventi.join(","),
            idAziendaSiert: idAziendaSiert.toString(),
        });
        const response = await fetch(`${BaseUrl}/catasti/siert/check?${params}`, {
            method: "GET",
            credentials: "include",
            mode: "cors",
            headers: { "Accept": "application/json" },
        });
        if (!response.ok)
            throw new Error(`Errore server: ${response.status}`);
        return await response.json() as ValidationError[];
    }

    /** Scarica il file SIERT. Chiamare checkSiert prima per verificare gli errori. */
    async downloadSiert(idInterventi: number[], idAziendaSiert: number): Promise<void> {
        const fileResponse = await new CatastiClient().getSiertExport(idInterventi.join(","), idAziendaSiert);
        if (fileResponse != null) {
            // @ts-ignore
            import("file-saver").then(instance => {
                instance.default.saveAs(fileResponse.data, fileResponse.fileName ?? "export-siert.txt");
            });
        }
    }

    async downloadEsa(idInterventi: number[]): Promise<void> {
        const fileResponse = await new CatastiClient().getEsaExport(idInterventi.join(","));
        if (fileResponse != null) {
            // @ts-ignore
            import("file-saver").then(instance => {
                instance.default.saveAs(fileResponse.data, fileResponse.fileName ?? "export-esa.csv");
            });
        }
    }
}

export default new CatastiActions();
